import { render } from "./footer.vue?vue&type=template&id=27b597f6&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=27b597f6&lang=scss&scoped=true"

import exportComponent from "E:\\liuniuWork\\example\\IPv6\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b597f6"]])

export default __exports__